import { memo } from 'react';
import styled from '@emotion/styled';

import { useNavLink } from '../../../lib/useNavLinks';
import DesktopNav from './Desktop/Nav';
import MobileNav from './Mobile';

const MobileNavWrapper = styled('div')`
  @media (min-width: 768px) {
    display: none;
  }
`;

const DesktopNavWrapper = styled('div')`
  display: none;

  @media (min-width: 768px) {
    display: inherit;
    width: 100%;
  }
`;

function Nav() {
  const pages = useNavLink();

  if (typeof pages !== 'undefined' && pages !== null && pages.length > 0) {
    return (
      <>
        <DesktopNavWrapper data-testid="desktop-nav-wrapper">
          <DesktopNav pages={pages} />
        </DesktopNavWrapper>
        <MobileNavWrapper data-testid="mobile-nav-wrapper">
          <MobileNav pages={pages} />
        </MobileNavWrapper>
      </>
    );
  }

  return <></>;
}

export default memo(Nav);
